import { render, staticRenderFns } from "./setAclToGroups.vue?vue&type=template&id=6ee1fb9e"
import script from "./setAclToGroups.vue?vue&type=script&lang=js"
export * from "./setAclToGroups.vue?vue&type=script&lang=js"
import style0 from "./setAclToGroups.vue?vue&type=style&index=0&id=6ee1fb9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports